module.exports = __webpack_public_path__ + "static/media/cert_quwan.575c69cf.jpg";